'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

var _angularFix = require('angular-fix');

var _angularFix2 = _interopRequireDefault(_angularFix);

var _otherUtils = require('../other/utils');

var _otherUtils2 = _interopRequireDefault(_otherUtils);

exports['default'] = formlyConfig;

// @ngInject
function formlyConfig(formlyUsabilityProvider, formlyErrorAndWarningsUrlPrefix, formlyApiCheck) {
  var _this2 = this;

  var typeMap = {};
  var templateWrappersMap = {};
  var defaultWrapperName = 'default';
  var _this = this;
  var getError = formlyUsabilityProvider.getFormlyError;

  _angularFix2['default'].extend(this, {
    setType: setType,
    getType: getType,
    getTypes: getTypes,
    getTypeHeritage: getTypeHeritage,
    setWrapper: setWrapper,
    getWrapper: getWrapper,
    getWrapperByType: getWrapperByType,
    removeWrapperByName: removeWrapperByName,
    removeWrappersForType: removeWrappersForType,
    disableWarnings: false,
    extras: {
      disableNgModelAttrsManipulator: false,
      fieldTransform: [],
      ngModelAttrsManipulatorPreferUnbound: false,
      removeChromeAutoComplete: false,
      defaultHideDirective: 'ng-if',
      getFieldId: null
    },
    templateManipulators: {
      preWrapper: [],
      postWrapper: []
    },
    $get: function $get() {
      return _this2;
    }
  });

  function setType(options) {
    if (_angularFix2['default'].isArray(options)) {
      var _ret = (function () {
        var allTypes = [];
        _angularFix2['default'].forEach(options, function (item) {
          allTypes.push(setType(item));
        });
        return {
          v: allTypes
        };
      })();

      if (typeof _ret === 'object') return _ret.v;
    } else if (_angularFix2['default'].isObject(options)) {
      checkType(options);
      if (options['extends']) {
        extendTypeOptions(options);
      }
      typeMap[options.name] = options;
      return typeMap[options.name];
    } else {
      throw getError('You must provide an object or array for setType. You provided: ' + JSON.stringify(arguments));
    }
  }

  function checkType(options) {
    formlyApiCheck['throw'](formlyApiCheck.formlyTypeOptions, options, {
      prefix: 'formlyConfig.setType',
      url: 'settype-validation-failed'
    });
    if (!options.overwriteOk) {
      checkOverwrite(options.name, typeMap, options, 'types');
    } else {
      options.overwriteOk = undefined;
    }
  }

  function extendTypeOptions(options) {
    var extendsType = getType(options['extends'], true, options);
    extendTypeControllerFunction(options, extendsType);
    extendTypeLinkFunction(options, extendsType);
    extendTypeDefaultOptions(options, extendsType);
    _otherUtils2['default'].reverseDeepMerge(options, extendsType);
    extendTemplate(options, extendsType);
  }

  function extendTemplate(options, extendsType) {
    if (options.template && extendsType.templateUrl) {
      delete options.templateUrl;
    } else if (options.templateUrl && extendsType.template) {
      delete options.template;
    }
  }

  function extendTypeControllerFunction(options, extendsType) {
    var extendsCtrl = extendsType.controller;
    if (!_angularFix2['default'].isDefined(extendsCtrl)) {
      return;
    }
    var optionsCtrl = options.controller;
    if (_angularFix2['default'].isDefined(optionsCtrl)) {
      options.controller = function ($scope, $controller) {
        $controller(extendsCtrl, { $scope: $scope });
        $controller(optionsCtrl, { $scope: $scope });
      };
      options.controller.$inject = ['$scope', '$controller'];
    } else {
      options.controller = extendsCtrl;
    }
  }

  function extendTypeLinkFunction(options, extendsType) {
    var extendsFn = extendsType.link;
    if (!_angularFix2['default'].isDefined(extendsFn)) {
      return;
    }
    var optionsFn = options.link;
    if (_angularFix2['default'].isDefined(optionsFn)) {
      options.link = function () {
        extendsFn.apply(undefined, arguments);
        optionsFn.apply(undefined, arguments);
      };
    } else {
      options.link = extendsFn;
    }
  }

  function extendTypeDefaultOptions(options, extendsType) {
    var extendsDO = extendsType.defaultOptions;
    if (!_angularFix2['default'].isDefined(extendsDO)) {
      return;
    }
    var optionsDO = options.defaultOptions || {};
    var optionsDOIsFn = _angularFix2['default'].isFunction(optionsDO);
    var extendsDOIsFn = _angularFix2['default'].isFunction(extendsDO);
    if (extendsDOIsFn) {
      options.defaultOptions = function defaultOptions(opts, scope) {
        var extendsDefaultOptions = extendsDO(opts, scope);
        var mergedDefaultOptions = {};
        _otherUtils2['default'].reverseDeepMerge(mergedDefaultOptions, opts, extendsDefaultOptions);
        var extenderOptionsDefaultOptions = optionsDO;
        if (optionsDOIsFn) {
          extenderOptionsDefaultOptions = extenderOptionsDefaultOptions(mergedDefaultOptions, scope);
        }
        _otherUtils2['default'].reverseDeepMerge(extenderOptionsDefaultOptions, extendsDefaultOptions);
        return extenderOptionsDefaultOptions;
      };
    } else if (optionsDOIsFn) {
      options.defaultOptions = function defaultOptions(opts, scope) {
        var newDefaultOptions = {};
        _otherUtils2['default'].reverseDeepMerge(newDefaultOptions, opts, extendsDO);
        return optionsDO(newDefaultOptions, scope);
      };
    }
  }

  function getType(name, throwError, errorContext) {
    if (!name) {
      return undefined;
    }
    var type = typeMap[name];
    if (!type && throwError === true) {
      throw getError('There is no type by the name of "' + name + '": ' + JSON.stringify(errorContext));
    } else {
      return type;
    }
  }

  function getTypes() {
    return typeMap;
  }

  function getTypeHeritage(parent) {
    var heritage = [];
    var type = parent;
    if (_angularFix2['default'].isString(type)) {
      type = getType(parent);
    }
    parent = type['extends'];
    while (parent) {
      type = getType(parent);
      heritage.push(type);
      parent = type['extends'];
    }
    return heritage;
  }

  function setWrapper(_x, _x2) {
    var _again = true;

    _function: while (_again) {
      var options = _x,
          name = _x2;
      _again = false;

      if (_angularFix2['default'].isArray(options)) {
        return options.map(function (wrapperOptions) {
          return setWrapper(wrapperOptions);
        });
      } else if (_angularFix2['default'].isObject(options)) {
        options.types = getOptionsTypes(options);
        options.name = getOptionsName(options, name);
        checkWrapperAPI(options);
        templateWrappersMap[options.name] = options;
        return options;
      } else if (_angularFix2['default'].isString(options)) {
        _x = {
          template: options,
          name: name
        };
        _x2 = undefined;
        _again = true;
        continue _function;
      }
    }
  }

  function getOptionsTypes(options) {
    if (_angularFix2['default'].isString(options.types)) {
      return [options.types];
    }
    if (!_angularFix2['default'].isDefined(options.types)) {
      return [];
    } else {
      return options.types;
    }
  }

  function getOptionsName(options, name) {
    return options.name || name || options.types.join(' ') || defaultWrapperName;
  }

  function checkWrapperAPI(options) {
    formlyUsabilityProvider.checkWrapper(options);
    if (options.template) {
      formlyUsabilityProvider.checkWrapperTemplate(options.template, options);
    }
    if (!options.overwriteOk) {
      checkOverwrite(options.name, templateWrappersMap, options, 'templateWrappers');
    } else {
      delete options.overwriteOk;
    }
    checkWrapperTypes(options);
  }

  function checkWrapperTypes(options) {
    var shouldThrow = !_angularFix2['default'].isArray(options.types) || !options.types.every(_angularFix2['default'].isString);
    if (shouldThrow) {
      throw getError('Attempted to create a template wrapper with types that is not a string or an array of strings');
    }
  }

  function checkOverwrite(property, object, newValue, objectName) {
    if (object.hasOwnProperty(property)) {
      warn('overwriting-types-or-wrappers', ['Attempting to overwrite ' + property + ' on ' + objectName + ' which is currently', JSON.stringify(object[property]) + ' with ' + JSON.stringify(newValue), 'To supress this warning, specify the property "overwriteOk: true"'].join(' '));
    }
  }

  function getWrapper(name) {
    return templateWrappersMap[name || defaultWrapperName];
  }

  function getWrapperByType(type) {
    /* eslint prefer-const:0 */
    var wrappers = [];
    for (var _name in templateWrappersMap) {
      if (templateWrappersMap.hasOwnProperty(_name)) {
        if (templateWrappersMap[_name].types && templateWrappersMap[_name].types.indexOf(type) !== -1) {
          wrappers.push(templateWrappersMap[_name]);
        }
      }
    }
    return wrappers;
  }

  function removeWrapperByName(name) {
    var wrapper = templateWrappersMap[name];
    delete templateWrappersMap[name];
    return wrapper;
  }

  function removeWrappersForType(type) {
    var wrappers = getWrapperByType(type);
    if (!wrappers) {
      return undefined;
    }
    if (!_angularFix2['default'].isArray(wrappers)) {
      return removeWrapperByName(wrappers.name);
    } else {
      wrappers.forEach(function (wrapper) {
        return removeWrapperByName(wrapper.name);
      });
      return wrappers;
    }
  }

  function warn() {
    if (!_this.disableWarnings && console.warn) {
      /* eslint no-console:0 */
      var args = Array.prototype.slice.call(arguments);
      var warnInfoSlug = args.shift();
      args.unshift('Formly Warning:');
      args.push('' + formlyErrorAndWarningsUrlPrefix + warnInfoSlug);
      console.warn.apply(console, _toConsumableArray(args));
    }
  }
}
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./providers/formlyConfig.js
 **/